import { FC, SVGProps } from "react";

export const CloseIconSvg: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="25"
    viewBox="0 0 24 25"
    fill="none"
    className="stroke-zinc-900"
    {...props}
  >
    <path d="M4.00012 4.5L20.9707 21.4706" strokeWidth="2" />
    <path d="M20.9706 4.5L4.00002 21.4706" strokeWidth="2" />
  </svg>
);
